module.exports = __webpack_public_path__ + "img/6.4b3fb2a9.png";